export default "__VITE_ASSET__305964ea__"